import React from 'react'

import { SvgIcon } from '@mui/material'

export const path = `
M9.631 16.578a6.75 6.75 0 1 0 0-13.5 6.75 6.75 0 0 0 0 13.5zm2.697-10.186c.198 0 .388.078.529.219
a.752.752 0 0 1 0 1.05l-2.168 2.167 2.168 2.168a.747.747 0 1 1-1.058 1.057l-2.168-2.167-2.167 2.167
a.747.747 0 1 1-1.058-1.057l2.168-2.168-2.168-2.167a.747.747 0 1 1 1.058-1.058l2.167 2.168L11.8 6.61
c.14-.14.33-.22.529-.22z
`

export default props => (
  <SvgIcon color="error" {...props} viewBox="0 0 19 19">
    <path fillRule="evenodd" clipRule="evenodd" d={path} />
  </SvgIcon>
)
